{
  "headers": {
    "primary": "Log in to EZ Texting",
    "secondary": "Connect your EZ Texting account to Campanion."
  },
  "inputs": {
    "username": {
      "label": "Email or Username"
    },
    "password": {
      "label": "Password"
    }
  },
  "buttons": {
    "submit": "Connect Account"
  },
  "errors": {
    "invalid": "Invalid Username/Password",
    "generic": "An error has occurred. Please try again."
  },
  "alerts": {
    "connectionBroken": {
      "title": "Connection Broken",
      "description": "Please Login again"
    }
  }
}
